/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/Footer.js";
import Button from "components/CustomButtons/Button.js";

import LoadingData from '../lottieLoading.js';

// views for this page
import ReviewOrder from "../../../trade-customer-portal/views/ReviewOrderPage/Sections/RecentOrders.js"
import FooterSection from "trade-customer-portal/views/footer.js"
import HeaderSection from "trade-customer-portal/views/header.js";
import { useDispatch, useSelector } from "react-redux";

// styling 
import reviewOrderPageStyle from "assets/jss/CustomerTradePortal/views/reviewOrderPageStyle.js";
import { BorderBottom } from "@material-ui/icons";
const useStyles = makeStyles(reviewOrderPageStyle);

export default function ReviewOrderPage() {

    const loading = useSelector(state => state.userReducer.loadingPage);

    React.useEffect(() => {
        window.scrollTo(0, 0);
    });

    function TestingAuth() {
        //console.log("hello")
    }

    const classes = useStyles();

    return (
        <div >
            <HeaderSection />

            <div className={classNames(classes.main, classes.mainRaised, classes.mainSection, classes.sidePageMainSection)}>
                <div className={classes.container}>
                    <GridContainer justify="center">
                        <GridItem
                            md={7}
                            sm={8}
                            className={classNames(
                                classes.mlAuto,
                                classes.mrAuto,
                                classes.textCenter
                            )}
                        >
                            <h1 className={classes.title} style={{ color: "black" }}>Review Your Order</h1>
                        </GridItem>
                        <GridItem md={7} sm={8} className={classNames(classes.mlAuto, classes.mrAuto)}>
                            <div className={classes.sidePageBorderLine} />
                        </GridItem>
                    </GridContainer>
                    <ReviewOrder />
                    <br />
                </div>
            </div>

            <FooterSection />

            {loading && <LoadingData text={"Please Wait...."} />}
        </div>
    );
}